import { UserInfo } from '@microsoft/teamsfx';

import { AppError } from 'src/errors';
import { ERROR_MESSAGES } from 'src/utils/constants';
import { ErrorCodes, LogSeverity } from 'src/utils/enums';

type UiErrorConstructorParams = {
  message: string
  componentStack?: string | null
  user?: UserInfo | null
  originalError?: unknown
  context?: Record<string, unknown>
};

export class UiError extends AppError {
  constructor({ message, componentStack, user, originalError, context }: UiErrorConstructorParams) {
    super({
      name: 'UiError',
      message,
      errorCode: ErrorCodes.UI,
      user,
      originalError,
      context: { ...context, componentStack },
    });
  }
}

export function handleUiError(error: unknown, componentStack?: string | null, logSeverity?: LogSeverity): void {
  if (error instanceof AppError && error.isLogged) {
    return; // Avoid duplicate logs.
  }

  const message = error instanceof Error ? error.message : ERROR_MESSAGES.unknownError;

  const uiError = new UiError({ message, componentStack, originalError: error });

  uiError.logError(logSeverity);
}
